import { FC, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { RenderNextStepProps } from "./types";
import {  PrecertAPIResponse } from "../precert/types";
import { LoaderContext } from "src/context/loaderContext";
import useAppealButtonFunc from "src/hooks/useAppealButtonFunc";




const RenderNextStep: FC<RenderNextStepProps> = ({ kase , showHideModalForTreatment, setDataForCancelModal, getCaseListing }): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const navigate = useNavigate();
  const { submiAppealForCase, apiInPorgress } = useAppealButtonFunc();




  const { mutate: updateCaseMutate, data: updateCaseResponse } =
    useFetch<PrecertAPIResponse>(APIEndpoints.UPDATE_CASES, {}, {}, false);

  useEffect(() => {
    if (updateCaseResponse){
      showToast([updateCaseResponse.message || `Case Updated Successfully`],ToastTypes.SUCCESS)
      getCaseListing()
    }
     
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCaseResponse]);

  const buyAndBillButton = (caseID: number) => {
    updateCaseMutate({ case: { status_name: "Pulled From Stock", color_idx: 3, skip_update_case_status: "true" } }, { caseId: caseID }, {})
  }







  const navigateToPrecertForm = (caseId: number, precertId: number) => {
    const pathParams = {
      case_id: caseId,
      id: precertId
    }
    navigate(`/cases/${pathParams.case_id}/precerts/${pathParams.id}/edit`);
  }

  // const navigateToReviewPrecertForm = (caseId: number, precertId: number) => {
  //   navigate(`/cases/${caseId}/precerts/${precertId}/review`);
  // }


  const { loading: transferRxLoading, data: transferRxData, mutate: transferRxByCaseId } =
    useFetch(APIEndpoints.TRANSFER_RX, {}, { case_id: kase.id });

  useEffect(() => {
    if (transferRxData) {
      const { message } = transferRxData as unknown as { code: number; message: string; };
      showToast([message], ToastTypes.SUCCESS);
      getCaseListing();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxData]);

  useEffect(() => {
    if (transferRxLoading) setLoader();
    else hideLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxLoading]);

  const ConfirmAlert = (title: string,buttonName:string,caseId:number ) => {
    const result = window.confirm(title);
    if (result) {
      if(buttonName === 'xFerToSP') {
        transferRxByCaseId({}, { case_id: caseId }, {})
      }else if (buttonName === "patientPurchase"){
        transferRxByCaseId({}, { case_id: caseId }, { pdp: 1 })
      }
    }
  };



  const caseAction = [];

  if (!kase.cancelled_state) {
    if (kase.active_precert) {
      caseAction.push(
        <button
          className="btn btn-warning m-1 text-white text-nowrap"
          onClick={() => { navigateToPrecertForm(kase.id, kase.active_precert_id) }}
        >
          <i className="fas fa-clipboard-list me-2"></i> Precert
        </button>)
    }
    if (kase.transfer_rx_button || kase.xfer_rx_sp) {
      caseAction.push(
        <button
          className="btn btn-success m-1 background-color-3"
          onClick={() => ConfirmAlert('Are you sure you want to transfer this prescription? This cannot be undone!',"xFerToSP",kase.id)}
        >
          <i className="fas fa-prescription me-2"></i> Xfer to SP
        </button>)
    } else if (kase.pdp_xfer) {
      caseAction.push(
        <button
          className="btn btn-success m-1 background-color-3"
          onClick={() => ConfirmAlert('Are you sure you want to transfer this prescription? This cannot be undone!',"patientPurchase",kase.id)}
        >
          <i className="fas fa-user me-2"></i> Patient Direct
        </button>)
    }
    if (kase.buy_and_bill) {
      caseAction.push(
        <button
          className="btn btn-success m-1 background-color-3"
        onClick={() => { buyAndBillButton(kase.id) }}
        >
          <i className="far fa-hospital me-2"></i> Buy & Bill
        </button>)
    }
    //blue karna ha 
    // if (kase.precert_maximum) {
    //   caseAction.push(
    //     <button
    //       className="btn text-white m-1" style={{ backgroundColor: "#337ab7" }}
    //     onClick={() => { navigateToReviewPrecertForm(kase.id, kase.pending_precert_id || 0) }}
    //     >
    //       <i className="fas fa-clipboard-list me-2"></i> Review
    //     </button>)
    // }
    if (kase.precert_minimum) {
      caseAction.push(
        <button className="btn btn-success m-1 background-color-3"
          disabled={apiInPorgress}
          onClick={() => submiAppealForCase(kase.id, kase.appeal_precert_id)}
        >
          <i className="fas fa-clipboard-list me-2"></i>
          Appeal
        </button>
  
      )
    }
    // if (kase.xfer_confirmed && caseAction.length === 0) {
    //   caseAction.push(<p className="fs-6 mb-0">Review Case Notes</p>);
    // }
    if (caseAction.length === 0) {
      caseAction.push("");
    }
  } else {
    caseAction.push(<p className="fs-6 mb-0">No Action Required</p>);
  }

  return (
    <>
      {caseAction}
    </>
  );
};

export default RenderNextStep;
